<template>
  <div
    class="w-100 text-center "
    style="max-width: 480px; margin:0 auto"
  >
    <div class="my-3 mx-n2 mx-md-n3 mx-lg-n4">
      <div
        class="position-relative w-100 d-flex justify-content-center align-items-center"
        :style="cssprops"
      >
        <!-- 上傳自定義圖片 begin -->
        <img
          v-if="bgDisplayImg !== ''"
          :src="bgDisplayImg"
        >
        <!-- 上傳自定義圖片 end -->
        <!-- 預設圖片，可選深色淺色，顏色更改頁面最下方.slot-svg-fill的色碼 begin -->
        <svg
          v-if="bgDisplayImg === ''"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 350 310"
          style="width:350px;height:310px;min-width:350px;min-height:310px;"
        >
          <g
            id="slot-02"
            data-name="slot 1"
          >
            <path
              class="slot-svg-fill"
              d="M175,49.5c24.9,0,49.4,4,70.9,11.6a155,155,0,0,1,33.4,16.4H70.7a155,155,0,0,1,33.4-16.4c21.5-7.6,46-11.6,70.9-11.6m0-8c-53.5,0-100.4,17.6-126.9,44H301.9c-26.5-26.4-73.4-44-126.9-44Z"
            />
            <path
              class="slot-svg-fill"
              d="M332.5,85.5A9.6,9.6,0,0,1,342,95V215a9.6,9.6,0,0,1-9.5,9.5H17.5A9.6,9.6,0,0,1,8,215V95a9.6,9.6,0,0,1,9.5-9.5h315m0-8H17.5A17.5,17.5,0,0,0,0,95V215a17.5,17.5,0,0,0,17.5,17.5h315A17.5,17.5,0,0,0,350,215V95a17.5,17.5,0,0,0-17.5-17.5Z"
            />
            <path
              class="slot-svg-fill"
              d="M279,275.5a9.6,9.6,0,0,1,9.5,9.5v1a9.6,9.6,0,0,1-9.5,9.5H71a9.6,9.6,0,0,1-9.5-9.5v-1a9.6,9.6,0,0,1,9.5-9.5H279m0-8H71A17.5,17.5,0,0,0,53.5,285v1A17.5,17.5,0,0,0,71,303.5H279A17.5,17.5,0,0,0,296.5,286v-1A17.5,17.5,0,0,0,279,267.5Z"
            />
            <polygon
              class="slot-svg-fill"
              points="52.9 49.3 55.7 54.9 61.9 55.8 57.4 60.2 58.5 66.4 52.9 63.5 47.3 66.4 48.4 60.2 43.9 55.8 50.1 54.9 52.9 49.3"
            />
            <polygon
              class="slot-svg-fill"
              points="297.1 49.3 299.9 54.9 306.1 55.8 301.6 60.2 302.7 66.4 297.1 63.5 291.5 66.4 292.6 60.2 288.1 55.8 294.3 54.9 297.1 49.3"
            />
            <polygon
              class="slot-svg-fill"
              points="175 1.9 180.2 12.5 191.9 14.2 183.4 22.4 185.4 34 175 28.5 164.6 34 166.6 22.4 158.1 14.2 169.8 12.5 175 1.9"
            />
            <polygon
              class="slot-svg-fill"
              points="105.2 20.8 108.7 27.8 116.4 28.9 110.8 34.4 112.1 42.1 105.2 38.4 98.3 42.1 99.6 34.4 94 28.9 101.7 27.8 105.2 20.8"
            />
            <polygon
              class="slot-svg-fill"
              points="244.8 20.8 248.3 27.8 256 28.9 250.4 34.4 251.7 42.1 244.8 38.4 237.9 42.1 239.2 34.4 233.6 28.9 241.3 27.8 244.8 20.8"
            />
            <circle
              class="slot-svg-fill"
              cx="35.3"
              cy="249.8"
              r="5.7"
            />
            <circle
              class="slot-svg-fill"
              cx="60.7"
              cy="249.8"
              r="5.7"
            />
            <circle
              class="slot-svg-fill"
              cx="86.1"
              cy="249.8"
              r="5.7"
            />
            <circle
              class="slot-svg-fill"
              cx="111.5"
              cy="249.8"
              r="5.7"
            />
            <circle
              class="slot-svg-fill"
              cx="136.9"
              cy="249.8"
              r="5.7"
            />
            <circle
              class="slot-svg-fill"
              cx="162.3"
              cy="249.8"
              r="5.7"
            />
            <circle
              class="slot-svg-fill"
              cx="187.7"
              cy="249.8"
              r="5.7"
            />
            <circle
              class="slot-svg-fill"
              cx="213.1"
              cy="249.8"
              r="5.7"
            />
            <circle
              class="slot-svg-fill"
              cx="238.5"
              cy="249.8"
              r="5.7"
            />
            <circle
              class="slot-svg-fill"
              cx="263.9"
              cy="249.8"
              r="5.7"
            />
            <circle
              class="slot-svg-fill"
              cx="289.3"
              cy="249.8"
              r="5.7"
            />
            <circle
              class="slot-svg-fill"
              cx="314.7"
              cy="249.8"
              r="5.7"
            />
          </g>
        </svg>
        <!-- 預設圖片，可選深色淺色，顏色更改頁面最下方.slot-svg-fill的色碼 end -->
        <div class="d-flex justify-content-center align-items-center position-absolute slot-frame">
          <div
            id="casino1"
            class="slotMachine"
          >
            <div
              v-for="it in slotItem"
              :key="it.name"
              class="slot slot1"
              :style="`background-image: url('${it.image}'); background-color: #fff;`"
            />
          </div>
          <div
            id="casino2"
            class="slotMachine"
          >
            <div
              v-for="it in slotItem"
              :key="it.name"
              class="slot slot1"
              :style="`background-image: url('${it.image}'); background-color: #fff;`"
            />
          </div>
          <div
            id="casino3"
            class="slotMachine"
          >
            <div
              v-for="it in slotItem"
              :key="it.name"
              class="slot slot1"
              :style="`background-image: url('${it.image}'); background-color: #fff;`"
            />
          </div>
        </div>
      </div>
    </div>
    <b-button
      id="casinoShuffle"
      class="w-100 border-0 font-weight-bold"
      :disabled="finished"
      :style="`background: rgba(${buttonColor}, 1.0); color: rgba(${buttonColor === '255,255,255' ? '0,0,0' : '255,255,255'},1.0);`"
    >
      {{ buttonWording }}
    </b-button>
  </div>
</template>
<script>
import '@/assets/Slots/js/slotmachine';
import '@/assets/Slots/css/jquery.slotmachine.css';

export default {
  props: {
    // 拉霸主題配色
    colorType: {
      type: Number,
      required: true,
    },
    // 拉霸配色
    color: {
      type: String,
      required: true,
    },
    buttonWording: {
      type: String,
      required: true,
    },
    buttonColor: {
      type: String,
      required: true,
    },
    bgDisplayImg: {
      type: String,
      required: true,
    },
    // 獎品
    item: {
      type: Object,
      required: true,
    },
    itemlist: {
      type: Array,
      required: true,
    },
    // 是否可以玩
    isPlay: {
      type: Boolean,
      default: false,
    },
    activityconfirmpopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      finished: false,
      SlotResult: [],
      slotItem: this.itemlist.filter((x) => x.detail.every((y) => y.categoryName !== '未中獎')),
      mCasino1: null,
      mCasino2: null,
      mCasino3: null,
    };
  },
  computed: {
    cssprops() {
      return { '--turntable-color': `rgba(${this.color},1)` };
    },
  },
  watch: {
    isPlay() {
      if (this.isPlay && this.activityconfirmpopup) {
        this.finished = true;
        this.play();
      }
    },
  },
  created() {

  },
  mounted() {
    const vm = this;
    // let count = 0;
    const btnShuffle = document.querySelector('#casinoShuffle');
    const casino1 = document.querySelector('#casino1');
    const casino2 = document.querySelector('#casino2');
    const casino3 = document.querySelector('#casino3');
    // 只為了不讓拉霸圖片跑版
    /* eslint-disable-next-line no-unused-vars */
    this.mCasino1 = new window.SlotMachine(casino1, {
      active: 0,
      delay: 500,
      randomize() { return vm.SlotResult[0]; },
    });
    /* eslint-disable-next-line no-unused-vars */
    this.mCasino2 = new window.SlotMachine(casino2, {
      active: 1,
      delay: 500,
      randomize() { return vm.SlotResult[1]; },
    });
    /* eslint-disable-next-line no-unused-vars */
    this.mCasino3 = new window.SlotMachine(casino3, {
      active: 2,
      delay: 500,
      randomize() { return vm.SlotResult[2]; },
    });
    btnShuffle.addEventListener('click', () => {
      if (!this.isPlay) {
        this.$emit('show');
      } else {
        this.finished = true;
        this.play();
      }
    });
  },
  // destroyed() {
  //   // let count = 0;
  //   document.querySelector('#casinoShuffle').removeEventListener();
  // },
  methods: {
    getRandomInt() {
      if (this.item.isPrize) {
        const num = this.slotItem.findIndex((x) => x.name === this.item.itemInfo.name);
        for (let index = 0; index < 3; index += 1) {
          this.SlotResult.push(num);
        }
      } else if (this.slotItem.length === 1) { // 當只有一個獎項，若中了未中獎顯示一樣的圖片
        this.SlotResult.push(0);
        this.SlotResult.push(0);
        this.SlotResult.push(0);
      } else {
        this.SlotResult.push(1);
        this.SlotResult.push(1);
        this.SlotResult.push(0);
      }
    },
    play() {
      const vm = this;
      vm.getRandomInt();
      // let count = 0;
      // const btnStop = document.querySelector('#casinoStop');
      this.mCasino1.shuffle(4);
      this.mCasino2.shuffle(8);
      this.mCasino3.shuffle(12, () => {
        vm.$emit('done');
      });
    },
  },
};
</script>
<style>
.slot-frame {width: 350px;min-width: 350px; height: 310px; top:0px;padding:16px;}
.slotMachine {width: 100px;min-width: 100px;height: 100px; margin: 2px; top: 0px; position: relative; border-radius: 8px; border:0!important;}
.slot-svg-fill { fill:var(--turntable-color);}
</style>
